import React from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const FormatPill = styled.span<{ $audio: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 24px;
  margin: 4px 6px 0 0;
  padding: 3px 9px;
  border: 1px solid
    ${({ $audio, theme }) =>
      $audio ? theme.navigation.accent : 'rgba(128, 128, 128, 0.38)'};
  border-radius: 999px;
  color: ${({ $audio, theme }) =>
    $audio ? theme.navigation.accent : theme.navigation.mutedText};
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;

  > .icon {
    width: auto;
    margin: 0 !important;
  }
`;

type Props = {
  audioAvailable?: boolean;
};

const BookFormatBadge: React.FC<Props> = ({ audioAvailable = false }) => {
  const { t } = useTranslation();

  const label = audioAvailable
    ? t('BookFormatTextAndAudio', 'Text + audio')
    : t('BookFormatTextOnly', 'Text only');

  return (
    <FormatPill
      $audio={audioAvailable}
      aria-label={
        audioAvailable
          ? t('BookFormatTextAndAudioA11y', 'Text and audio available')
          : label
      }
    >
      <Icon name={audioAvailable ? 'headphones' : 'book'} aria-hidden="true" />
      <span>{label}</span>
    </FormatPill>
  );
};

export default BookFormatBadge;
